// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2px5m","comment":"styles_comment__tsCu-"};